interface IProps {
  content: any;
}

const HeadManager = ({ content }: IProps) => {
  return content;
};

export default HeadManager;
